define('colors', function () {
    return {
        'yellow': '#fff52e',
        'green': '#22b573',
        'white': '#ffffff',
        'gray': '#5a616c',
        'darkGray': '#272c33',
        'lightGray': '#96999e',
        'darkBlue': '#1b4d71',
        'brick': '#b14821',
        'darkMustard': '#b17221',
        'purple': '#c35e7c',
        'blue': '#4FA2C3',
        'orangeBrick': '#b14821',
        'mustardYellow': '#b17221'
    }
});